export const navItems = [
  { label: "首页", href: "/" },
  { label: "深挖", href: "#deep" },
  { label: "合集", href: "#collections" },
  { label: "话题墙", href: "#topics" },
  { label: "讨论区", href: "#board" },
  { label: "线索台", href: "#evidence" },
];

export const mastheadMeta = {
  edition: "第 0487 期",
  date: "2026 年 9 月 12 日 · 星期六",
  weather: "编辑部值班中",
  slogan: "深挖隐情秘闻 · 还原实情底细",
};

export const heroFeature = {
  kicker: "今日要案 · 深挖",
  title: "一份被撤下的合同截图，如何让一档综艺停摆九十天",
  excerpt:
    "从匿名线索到完整的沟通记录与资金流向，我们按时间顺序复原了这场风波里的每一个节点，并交叉核对了两方当事人的说法，试图把表层之下的另一面拼齐。",
  tags: ["综艺停摆", "合同纠纷", "资金流向"],
  stats: [
    { label: "热度", value: "12.8 万" },
    { label: "讨论", value: "3,462" },
    { label: "证据链", value: "9 段" },
  ],
  author: "编辑部 · 深挖组",
  readTime: "12 分钟",
  image:
    "https://readdy.ai/api/search-image?query=Moody%20editorial%20magazine%20photography%20of%20scattered%20paper%20documents%20and%20red%20thread%20connecting%20small%20blank%20photos%20on%20a%20dark%20wooden%20desk%2C%20warm%20dim%20lamp%20light%2C%20cinematic%20investigative%20atmosphere%2C%20abstract%20blurred%20background%2C%20no%20readable%20text%2C%20rich%20shadow%20and%20high%20detail&width=900&height=1000&seq=hlk-hero-01&orientation=portrait",
};

export const heroIndex = [
  { no: "01", title: "片场风波：一场临时改期引发的连锁反应", meta: "更新 2 小时前 · 8 段证据" },
  { no: "02", title: "数据注水链路：从投放后台到榜单曲线", meta: "更新 5 小时前 · 6 段证据" },
  { no: "03", title: "代言塌房复盘：品牌 48 小时内的三次割席", meta: "更新 昨天 · 11 段证据" },
  { no: "04", title: "电竞内讧：训练室录音里的分歧起点", meta: "更新 昨天 · 4 段证据" },
  { no: "05", title: "供应链暗线：一批货为何突然改道", meta: "更新 前天 · 7 段证据" },
];

export const flashFeed = [
  { time: "09:42", tag: "急报", text: "某剧组临时更换主演，官方口径与场务说法出现出入" },
  { time: "09:15", tag: "回应", text: "涉事工作室发布简短声明，未回应资金流向部分" },
  { time: "08:56", tag: "新料", text: "三段新曝光的沟通记录与原时间线存在 6 天空档" },
  { time: "08:30", tag: "跟进", text: "合作品牌已下架关联物料，页面保留历史快照" },
  { time: "08:02", tag: "线索", text: "读者投稿：一份合同补充条款的出现时间值得推敲" },
  { time: "07:40", tag: "梳理", text: "编辑部更新「停摆档案」合集，补齐第四阶段节点" },
];

export const topics = [
  { name: "综艺停摆", count: 128 },
  { name: "合同纠纷", count: 96 },
  { name: "资本暗线", count: 88 },
  { name: "数据注水", count: 74 },
  { name: "片场风波", count: 69 },
  { name: "代言塌房", count: 61 },
  { name: "直播翻车", count: 57 },
  { name: "电竞内讧", count: 52 },
  { name: "供应链黑幕", count: 48 },
  { name: "品牌割席", count: 43 },
  { name: "团队解散", count: 38 },
  { name: "复出试水", count: 31 },
];

export const collections = [
  {
    title: "停摆档案",
    desc: "一档节目从改期到停播的完整时间线，逐日更新。",
    count: 12,
    unit: "期",
    updated: "2 小时前更新",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20desaturated%20still%20life%20of%20a%20folded%20newspaper%20stack%20and%20a%20vintage%20audio%20cassette%20on%20a%20beige%20linen%20surface%2C%20soft%20window%20light%2C%20editorial%20collage%20aesthetic%2C%20muted%20red%20accent%2C%20no%20readable%20text%2C%20clean%20minimal%20composition%2C%20fine%20grain&width=700&height=460&seq=hlk-col-01&orientation=landscape",
  },
  {
    title: "资金流向图解",
    desc: "把合同、流水与时间节点画成一张能看懂的图。",
    count: 8,
    unit: "辑",
    updated: "5 小时前更新",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20still%20life%20of%20coins%20and%20a%20crumpled%20receipt%20beside%20a%20fountain%20pen%20on%20cream%20paper%2C%20warm%20amber%20light%2C%20muted%20tones%2C%20minimal%20investigative%20magazine%20mood%2C%20no%20readable%20text%2C%20shallow%20depth%20of%20field%2C%20subtle%20grain&width=700&height=460&seq=hlk-col-02&orientation=landscape",
  },
  {
    title: "片场实录",
    desc: "现场碎片、通告单与场务口述的交叉整理。",
    count: 15,
    unit: "篇",
    updated: "昨天更新",
    image:
      "https://readdy.ai/api/search-image?query=Moody%20behind%20the%20scenes%20film%20set%20still%20life%20with%20a%20clapperboard%20and%20coiled%20cable%20on%20dark%20concrete%20floor%2C%20warm%20sunset%20light%20through%20blinds%2C%20muted%20cinematic%20tones%2C%20abstract%2C%20no%20readable%20text%2C%20high%20detail&width=700&height=460&seq=hlk-col-03&orientation=landscape",
  },
  {
    title: "塌房复盘",
    desc: "30 天内的事件回放、回应节奏与品牌动作。",
    count: 30,
    unit: "天",
    updated: "昨天更新",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20still%20life%20of%20scattered%20blank%20photo%20cards%20and%20a%20broken%20ceramic%20cup%20on%20a%20warm%20terracotta%20surface%2C%20soft%20natural%20light%2C%20minimal%20magazine%20aesthetic%2C%20muted%20palette%2C%20no%20readable%20text&width=700&height=460&seq=hlk-col-04&orientation=landscape",
  },
];

export const scoops = [
  {
    tag: "深挖",
    title: "三次改口：声明口径变化背后谁在定调",
    excerpt: "对比四份公开声明，措辞调整集中在同一句话上。",
    heat: "9.2 万",
    comments: 412,
    image:
      "https://readdy.ai/api/search-image?query=Warm%20minimal%20editorial%20photo%20of%20an%20open%20notebook%20with%20a%20red%20pen%20and%20a%20small%20magnifier%20on%20a%20cream%20desk%2C%20soft%20morning%20light%2C%20muted%20tones%2C%20no%20readable%20text%2C%20clean%20composition%2C%20subtle%20grain&width=640&height=420&seq=hlk-sc-01&orientation=landscape",
  },
  {
    tag: "线索",
    title: "读者投稿：一封补充条款的出现时间",
    excerpt: "投稿人称条款签署日晚于事发日，仍需进一步核实。",
    heat: "7.6 万",
    comments: 288,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20of%20sealed%20envelopes%20and%20a%20brass%20key%20on%20warm%20beige%20paper%2C%20soft%20diffused%20light%2C%20muted%20palette%2C%20minimal%20investigative%20mood%2C%20no%20readable%20text%2C%20shallow%20depth%20of%20field&width=640&height=420&seq=hlk-sc-02&orientation=landscape",
  },
  {
    tag: "跟进",
    title: "品牌割席时间线：48 小时里的三次动作",
    excerpt: "从隐藏海报到下架物料，节奏比声明更快。",
    heat: "6.9 万",
    comments: 231,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20still%20life%20of%20folded%20fabric%20swatches%20and%20a%20blank%20price%20tag%20on%20a%20warm%20sand%20surface%2C%20soft%20side%20light%2C%20muted%20earth%20tones%2C%20minimal%20magazine%20aesthetic%2C%20no%20readable%20text&width=640&height=420&seq=hlk-sc-03&orientation=landscape",
  },
  {
    tag: "梳理",
    title: "空档的六天：时间线里消失的那段",
    excerpt: "两版行程表对不上，我们把它逐日摊开对照。",
    heat: "6.1 万",
    comments: 197,
    image:
      "https://readdy.ai/api/search-image?query=Warm%20minimal%20photo%20of%20a%20stack%20of%20blank%20calendar%20cards%20and%20a%20pocket%20watch%20on%20a%20cream%20desk%2C%20soft%20light%2C%20muted%20tones%2C%20no%20readable%20text%2C%20clean%20editorial%20composition&width=640&height=420&seq=hlk-sc-04&orientation=landscape",
  },
  {
    tag: "图解",
    title: "把流水画成一张图：节点比金额更关键",
    excerpt: "四个关键节点决定了资金在链条里的停留方式。",
    heat: "5.4 万",
    comments: 168,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20still%20life%20of%20wooden%20blocks%20and%20a%20red%20graph%20pencil%20on%20warm%20paper%2C%20soft%20window%20light%2C%20muted%20palette%2C%20minimal%20infographic%20mood%2C%20no%20readable%20text%2C%20fine%20grain&width=640&height=420&seq=hlk-sc-05&orientation=landscape",
  },
  {
    tag: "现场",
    title: "训练室外的一小时：分歧从何开始",
    excerpt: "口述记录指向一次临时调整的战术安排。",
    heat: "4.8 万",
    comments: 143,
    image:
      "https://readdy.ai/api/search-image?query=Moody%20minimal%20photo%20of%20a%20closed%20metal%20door%20with%20warm%20light%20spilling%20through%20the%20gap%20in%20a%20dim%20corridor%2C%20cinematic%20muted%20tones%2C%20abstract%20editorial%20aesthetic%2C%20no%20readable%20text&width=640&height=420&seq=hlk-sc-06&orientation=landscape",
  },
];

export const evidenceChain = [
  {
    stage: "01",
    label: "线索收集",
    title: "匿名投稿与公开信息汇总",
    desc: "把散落在各处的投稿、公告与快照先归拢到同一张时间轴上。",
  },
  {
    stage: "02",
    label: "交叉验证",
    title: "多信源互相印证",
    desc: "至少两个独立信源指向同一节点，才会被标记为「已核实」。",
  },
  {
    stage: "03",
    label: "物证整理",
    title: "记录、流水与物料核对",
    desc: "对沟通记录、资金节点与已被撤下的物料做逐项核对。",
  },
  {
    stage: "04",
    label: "当事人回应",
    title: "留出完整的回应位置",
    desc: "所有争议点都标注回应状态，未获回应会如实说明。",
  },
  {
    stage: "05",
    label: "结论与更新",
    title: "标注确定性等级并持续跟进",
    desc: "结论分为已核实、待确认与存在出入三档，并随新线索更新。",
  },
];

export const threads = [
  {
    hot: true,
    author: "夜航船",
    avatar: "夜",
    avatarTone: "primary",
    title: "补充条款那个时间点，其实说明不了全部问题",
    excerpt: "我更在意的是第三次改口的动机，那份声明里有一句话被删掉了……",
    replies: 128,
    likes: 462,
    time: "32 分钟前",
  },
  {
    hot: false,
    author: "看料的老张",
    avatar: "张",
    avatarTone: "secondary",
    title: "把四份声明并排看，措辞调整的规律很明显",
    excerpt: "我做了一张对照表，主要集中在责任归属那几个词上，欢迎补充。",
    replies: 86,
    likes: 331,
    time: "1 小时前",
  },
  {
    hot: false,
    author: "南墙",
    avatar: "南",
    avatarTone: "accent",
    title: "品牌动作比声明更快，这里面有信息量",
    excerpt: "先隐藏再下架最后发声明，时间差本身就是一种态度表达。",
    replies: 64,
    likes: 208,
    time: "2 小时前",
  },
  {
    hot: false,
    author: "晚风收音",
    avatar: "晚",
    avatarTone: "secondary",
    title: "关于那六天，我这边有一条不同的线索",
    excerpt: "场务口述里提到的改期日期，和行程表差了整整两天，需要核实。",
    replies: 51,
    likes: 176,
    time: "3 小时前",
  },
];

export const editorColumns = [
  {
    name: "林述",
    role: "深挖组主笔",
    avatar: "林",
    title: "比起结论，我更想让你看到推导过程",
    excerpt: "把每一条判断的依据摊开，比给一个斩钉截铁的答案更重要。",
  },
  {
    name: "周叙",
    role: "证据复核",
    avatar: "周",
    title: "「已核实」这三个字，要用得很吝啬",
    excerpt: "确定性等级不是装饰，它决定了读者该以什么态度看待一条料。",
  },
  {
    name: "陈皮",
    role: "合集编辑",
    avatar: "陈",
    title: "合集存在的意义，是让线索不再散落",
    excerpt: "单条爆料会过期，成体系的合集才能被反复检索和引用。",
  },
];

export const footerLinks = [
  {
    title: "内容",
    items: ["今日要案", "深挖长文", "合集索引", "话题墙"],
  },
  {
    title: "参与",
    items: ["讨论区", "线索台", "读者投稿", "更正与澄清"],
  },
  {
    title: "关于",
    items: ["编辑部说明", "核实标准", "免责声明", "联系方式"],
  },
];